<div class="mx-4 mb-5 w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 sm:mx-5">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Social Posts Section
    </p>
    <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
      Edit Post
    </h2>
  </div>
</div>

<main class="mt-5 px-4 sm:px-5">
  <div class="grid grid-cols-12 gap-6">

    <!-- MAIN CONTENT -->
    <div class="col-span-12 min-w-0 2xl:col-span-9">
      <div *ngIf="isDataLoaded">
        <div class="w-full min-w-0 overflow-hidden rounded-2xl border border-gray-300 bg-white">

          <div class="grid min-w-0 grid-cols-12 gap-0">

            <!-- LEFT ACTIONS -->
            <aside class="col-span-12 border-b border-gray-200 bg-gray-50/80 p-4 md:col-span-1 md:border-b-0 md:border-r">
              <div class="flex flex-row items-center justify-center gap-2 md:flex-col md:gap-3">

                <button
                  mat-icon-button
                  class="manage-post-btn"
                  (click)="viewList()"
                  matTooltip="Done"
                  aria-label="Done"
                >
                  <mat-icon>done_outline</mat-icon>
                </button>

                <button
                  *ngIf="enableDelete === 1"
                  mat-icon-button
                  class="manage-post-btn"
                  (click)="openDeleteConfirm()"
                  [disabled]="isDeleteDisabled"
                  matTooltip="Delete"
                  matTooltipPosition="left"
                  [class.opacity-40]="isDeleteDisabled"
                  [class.cursor-not-allowed]="isDeleteDisabled"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>

                <div class="hidden h-px w-10 bg-gray-300 md:block"></div>

                <button
                  mat-icon-button
                  class="manage-post-btn"
                  (click)="nextPost()"
                  [disabled]="!nextId"
                  matTooltip="Next"
                  [matTooltipDisabled]="!nextId"
                  [class.opacity-40]="!nextId"
                  [class.cursor-not-allowed]="!nextId"
                >
                  <mat-icon>skip_next</mat-icon>
                </button>

                <button
                  mat-icon-button
                  class="manage-post-btn"
                  (click)="prevPost()"
                  [disabled]="!prevId"
                  matTooltip="Previous"
                  [matTooltipDisabled]="!prevId"
                  [class.opacity-40]="!prevId"
                  [class.cursor-not-allowed]="!prevId"
                >
                  <mat-icon>skip_previous</mat-icon>
                </button>

              </div>
            </aside>

            <!-- DELETE CONFIRM TEMPLATE -->
            <ng-template #confirmDeleteTmpl>
              <div class="flex flex-col gap-4">
                <p>Are you sure you want to delete this post?</p>

                <div class="flex flex-row items-center justify-center gap-2">
                  <button class="base-btn" (click)="deletePost()">Confirm</button>
                  <button class="base-btn" (click)="dialog.closeAll();">Cancel</button>
                </div>
              </div>
            </ng-template>

            <!-- FORM AREA -->
            <section class="col-span-12 min-w-0 md:col-span-11">
              <form
                [formGroup]="postForm"
                class="w-full min-w-0 bg-white p-5 sm:p-6 lg:p-8"
                (ngSubmit)="submit()"
              >

                <!-- FORM BODY -->
                <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">

                  <!-- LEFT COLUMN -->
                  <div class="min-w-0 rounded-2xl bg-gray-50/40 p-5">

                    <div class="mb-6">
                      <label class="mb-2 block text-sm font-semibold text-gray-700">
                        Choose Social Page/Site
                      </label>

                      <select
                        formControlName="site"
                        [ngStyle]="{
                          'background-color': postForm.get('site')?.disabled ? '#e5e7eb' : '',
                          'color': postForm.get('site')?.disabled ? '#9ca3af' : ''
                        }"
                        class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                      >
                        <option value>Choose Site</option>
                        <option *ngFor="let s of sites" [value]="s.Domain">
                          {{ s.Domain }}
                        </option>
                      </select>
                    </div>

                    <div *ngIf="feeds.length > 0" class="mb-6">
                      <label class="mb-2 block text-sm font-semibold text-gray-700">
                        Post Category
                      </label>

                      <select
                        formControlName="rss_feed_id"
                        [ngStyle]="{
                          'background-color': postForm.get('rss_feed_id')?.disabled ? '#e5e7eb' : '',
                          'color': postForm.get('rss_feed_id')?.disabled ? '#9ca3af' : ''
                        }"
                        class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                      >
                        <option value disabled>Select a Category</option>
                        <option *ngFor="let f of feeds" [value]="f.id">
                          {{ f.feed }}
                        </option>
                      </select>
                    </div>

                    <div *ngIf="postForm.get('rss_feed_id')?.value && filteredPlatforms.length > 0" class="mb-6">
                      <label class="mb-3 block text-sm font-semibold text-gray-700">
                        Choose Platform
                      </label>

                      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <label
                          *ngFor="let p of filteredPlatforms"
                          [ngStyle]="{
                            'background-color': postForm.get('platform')?.disabled ? '#e5e7eb' : '',
                            'color': postForm.get('platform')?.disabled ? '#9ca3af' : ''
                          }"
                          class="cursor-pointer rounded-xl border border-gray-300 bg-white p-4 transition hover:border-gray-400 hover:bg-gray-50"
                        >
                          <div class="flex items-start gap-3">
                            <input
                              type="radio"
                              formControlName="platform"
                              [value]="p.platform"
                              class="mt-1 text-blue-600 focus:ring-blue-500"
                            />

                            <span class="min-w-0 text-sm font-semibold text-gray-700">
                              {{ p.platform }}
                              <span class="mt-0.5 block truncate text-xs font-medium text-gray-400">
                                {{ p.domain }}
                              </span>
                            </span>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div *ngIf="filteredTags.length > 0" class="mb-6">
                      <label class="mb-2 block text-sm font-semibold text-gray-700">
                        Choose Format
                      </label>

                      <select
                        formControlName="tag"
                        [ngStyle]="{
                          'background-color': postForm.get('tag')?.disabled ? '#e5e7eb' : '',
                          'color': postForm.get('tag')?.disabled ? '#9ca3af' : ''
                        }"
                        class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                      >
                        <option value disabled>Select a tag</option>
                        <option *ngFor="let tag of filteredTags" [value]="tag">
                          {{ getDisplayTagLabel(tag) }}
                        </option>
                      </select>
                    </div>

                    <!-- TEXT DIRECTION -->
                    <div
                      *ngIf="postForm.get('tag')?.value"
                      class="mb-6 flex items-center justify-between gap-4 rounded-xl border border-gray-300 bg-white p-4"
                    >
                      <label class="block text-sm font-semibold text-gray-700">
                        Text Direction
                      </label>

                      <div class="inline-flex rounded-xl border border-gray-300 bg-gray-50 p-1">
                        <button
                          type="button"
                          (click)="$event.preventDefault(); $event.stopPropagation(); setTextDirection('ltr')"
                          [class.bg-white]="textDirection === 'ltr'"
                          [class.shadow]="textDirection === 'ltr'"
                          class="rounded-lg px-4 py-2 text-sm font-semibold text-gray-700 transition"
                          [disabled]="isEditBlocked"
                        >
                          LTR
                        </button>

                        <button
                          type="button"
                          (click)="$event.preventDefault(); $event.stopPropagation(); setTextDirection('rtl')"
                          [class.bg-white]="textDirection === 'rtl'"
                          [class.shadow]="textDirection === 'rtl'"
                          class="rounded-lg px-4 py-2 text-sm font-semibold text-gray-700 transition"
                          [disabled]="isEditBlocked"
                        >
                          RTL
                        </button>
                      </div>
                    </div>

                    <!-- VIDEO SECTION -->
                    <ng-container
                      *ngIf="
                        allVideoTags.includes(postForm.get('tag')?.value) ||
                        (!!id && postForm.get('video_type')?.value)
                      "
                    >

                      <div class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          Video Type
                        </label>

                        <select
                          formControlName="video_type"
                          [disabled]="isEditBlocked || !!id"
                          [ngStyle]="{
                            'background-color': postForm.get('video_type')?.disabled ? '#e5e7eb' : '',
                            'color': postForm.get('video_type')?.disabled ? '#9ca3af' : ''
                          }"
                          class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        >
                          <option value="video_upload">Upload A Video</option>
                          <option value="video_url">YouTube Link</option>
                        </select>
                      </div>

                      <div *ngIf="postForm.get('video_type')?.value === 'video_upload'" class="mb-6 text-center">
                        <label
                          class="inline-block cursor-pointer rounded-xl bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700"
                          [class.opacity-50]="isEditBlocked || !!id"
                          [class.pointer-events-none]="isEditBlocked || !!id"
                        >
                          Upload MP4 Video
                          <input
                            type="file"
                            accept="video/mp4"
                            (change)="onVideoFileSelected($event)"
                            class="hidden"
                            [disabled]="isEditBlocked || !!id"
                          />
                        </label>

                        <div *ngIf="videoFileName" class="mt-3 text-sm text-gray-600">
                          {{ videoFileName }}
                        </div>
                      </div>

                      <div *ngIf="postForm.get('video_type')?.value === 'video_url'" class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          Youtube URL
                        </label>

                        <input
                          type="text"
                          formControlName="video_url"
                          placeholder="https://youtube.com/watch?v=..."
                          [attr.dir]="textDirection"
                          [disabled]="isEditBlocked"
                          class="h-[44px] w-full rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        />
                      </div>

                    </ng-container>

                    <ng-container *ngIf="postForm.get('tag')?.value && postForm.get('tag')?.value !== 'photolink'">
                      <div class="mb-6">
                        <div class="mb-2 flex items-center justify-between gap-3">
                          <label class="block text-sm font-semibold text-gray-700">
                            Post Description
                          </label>

                          <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                            Alternative AI Prompt
                          </mat-checkbox>
                        </div>

                        <textarea
                          formControlName="rss_description"
                          rows="3"
                          placeholder="Enter description..."
                          [attr.dir]="textDirection"
                          class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        ></textarea>
                      </div>

                      <div class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          URL
                        </label>

                        <input
                          formControlName="rss_article_url"
                          type="text"
                          placeholder="https://..."
                          [attr.dir]="textDirection"
                          class="h-[44px] w-full rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        />

                        <div
                          *ngIf="postForm.get('rss_article_url')?.invalid && postForm.get('rss_article_url')?.touched"
                          class="mt-1 text-xs text-red-500"
                        >
                          <span *ngIf="postForm.get('rss_article_url')?.errors?.['pattern']">
                            Enter a valid URL (e.g., https://example.com).
                          </span>
                        </div>
                      </div>

                      <div class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          Caption
                        </label>

                        <textarea
                          formControlName="post_title"
                          rows="2"
                          placeholder="Enter title..."
                          [attr.dir]="textDirection"
                          class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        ></textarea>
                      </div>

                      <div class="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                          <label class="mb-2 block text-sm font-semibold text-gray-700">
                            Post Status
                          </label>

                          <select
                            formControlName="post_status"
                            class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                          >
                            <option value disabled>Select a status</option>
                            <option *ngFor="let s of filteredPostStatuses" [value]="s.value">
                              {{ s.label }}
                            </option>
                          </select>
                        </div>

                        <div>
                          <label class="mb-2 block text-sm font-semibold text-gray-700">
                            Schedule Date & Time
                          </label>

                          <input
                            type="datetime-local"
                            formControlName="scheduled_for"
                            [ngStyle]="{
                              'background-color': postForm.get('scheduled_for')?.disabled ? '#e5e7eb' : '',
                              'color': postForm.get('scheduled_for')?.disabled ? '#9ca3af' : ''
                            }"
                            class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                          />
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- RIGHT COLUMN -->
                  <div class="min-w-0 rounded-2xl bg-gray-50/40 p-5">

                    <!-- MEDIA CARD -->
                    <div
                      *ngIf="postForm.get('tag')?.value !== 'photolink'"
                      class="mb-6 rounded-2xl border border-gray-300 bg-white p-5"
                    >

                      <!-- SINGLE IMAGE BUTTON -->
                      <div
                        *ngIf="singleImageTags.includes(postForm.get('tag')?.value)"
                        class="mb-6 flex justify-center"
                        [class.pointer-events-none]="isEditBlocked"
                        [class.opacity-50]="isEditBlocked"
                      >
                        <label
                          class="cursor-pointer rounded-xl bg-blue-600 px-8 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700"
                        >
                          {{ imagePreview || uploadedFiles.length > 0 ? 'Change Image' : 'Choose Image' }}

                          <input
                            type="file"
                            (change)="onFileSelected($event)"
                            accept="image/*"
                            class="hidden"
                            [disabled]="isEditBlocked"
                          />
                        </label>
                      </div>

                      <!-- MULTI UPLOAD -->
                      <div
                        *ngIf="mediaTags.includes(postForm.get('tag')?.value) && !imagePreview && uploadedFiles.length === 0"
                        [class.pointer-events-none]="isEditBlocked"
                        [class.opacity-50]="isEditBlocked"
                        class="cursor-pointer rounded-2xl border-2 border-dashed border-gray-300 bg-gray-50 p-8 text-center transition hover:border-gray-400"
                        (drop)="isEditBlocked ? null : onFilesDropped($event)"
                        (dragover)="isEditBlocked ? null : onDragOver($event)"
                      >
                        <svg
                          class="mx-auto h-12 w-12 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                          ></path>
                        </svg>

                        <p class="mt-4 font-medium text-gray-500">
                          Drag & Drop your images here
                        </p>

                        <p class="mt-1 text-sm text-gray-400">
                          or click to browse images
                        </p>

                        <input
                          type="file"
                          multiple
                          (change)="onMultipleFilesSelected($event)"
                          class="hidden"
                          #fileInput
                          [disabled]="isEditBlocked"
                        />

                        <button
                          type="button"
                          [disabled]="isEditBlocked"
                          class="mt-4 cursor-pointer rounded-xl bg-blue-600 px-6 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
                          (click)="isEditBlocked ? null : fileInput.click()"
                        >
                          Select Images
                        </button>
                      </div>

                      <!-- SINGLE IMAGE PREVIEW -->
                      <div
                        *ngIf="imagePreview"
                        class="flex w-full justify-center"
                      >
                        <div
                          class="group relative h-[460px] w-[260px] overflow-hidden rounded-[28px] border border-gray-300 bg-gray-100 shadow-lg"
                        >
                          <img
                            [src]="imagePreview"
                            draggable="false"
                            class="absolute inset-0 h-full w-full object-cover"
                          />

                          <button
                            *ngIf="!isEditBlocked"
                            type="button"
                            (click)="removeImage()"
                            class="absolute right-3 top-3 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-red-600 text-sm font-bold text-white shadow-md opacity-0 transition-opacity duration-300 hover:bg-red-700 group-hover:opacity-100"
                          >
                            ✕
                          </button>
                        </div>
                      </div>

                      <!-- MULTIPLE IMAGE CAROUSEL -->
                      <div
                        *ngIf="!imagePreview && uploadedFiles.length > 0"
                        class="mt-6"
                      >
                        <div class="mb-4 flex justify-end">
                          <button
                            *ngIf="uploadedFiles.length > 1 && !isEditBlocked"
                            type="button"
                            class="cursor-pointer text-sm font-semibold text-red-600 hover:underline"
                            (click)="clearAll()"
                          >
                            Clear All
                          </button>
                        </div>

                        <div
                          *ngIf="uploadedFiles[carouselImageIndex] as currentImage"
                          class="w-full"
                        >
                          <!-- CAROUSEL FRAME -->
                          <div class="flex w-full items-center justify-center gap-3">

                            <!-- LEFT ARROW -->
                            <button
                              *ngIf="uploadedFiles.length > 1"
                              type="button"
                              class="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-white text-gray-700 shadow-sm transition hover:bg-gray-100"
                              (click)="prevCarouselImage()"
                            >
                              <mat-icon>chevron_left</mat-icon>
                            </button>

                            <!-- IMAGE -->
                            <div
                              class="group relative h-[460px] w-[260px] overflow-hidden rounded-[28px] border border-gray-300 bg-gray-100 shadow-lg"
                            >
                              <img
                                [src]="currentImage.preview"
                                alt="preview"
                                class="absolute inset-0 h-full w-full object-cover"
                              />

                              <!-- REMOVE -->
                              <button
                                *ngIf="!isEditBlocked"
                                type="button"
                                (click)="removeCarouselImage()"
                                class="absolute right-3 top-3 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-red-600 text-sm font-bold text-white shadow-md opacity-0 transition-opacity duration-300 hover:bg-red-700 group-hover:opacity-100"
                              >
                                ✕
                              </button>

                              <!-- COUNTER -->
                              <div
                                *ngIf="uploadedFiles.length > 1"
                                class="absolute left-1/2 top-3 z-10 -translate-x-1/2 rounded-full bg-black/55 px-3 py-1 text-xs font-semibold text-white"
                              >
                                {{ carouselImageIndex + 1 }} / {{ uploadedFiles.length }}
                              </div>
                            </div>

                            <!-- RIGHT ARROW -->
                            <button
                              *ngIf="uploadedFiles.length > 1"
                              type="button"
                              class="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-white text-gray-700 shadow-sm transition hover:bg-gray-100"
                              (click)="nextCarouselImage()"
                            >
                              <mat-icon>chevron_right</mat-icon>
                            </button>

                          </div>

                          <!-- DOTS -->
                          <div
                            *ngIf="uploadedFiles.length > 1"
                            class="mt-4 flex items-center justify-center gap-2"
                          >
                            <button
                              *ngFor="let img of uploadedFiles; let i = index"
                              type="button"
                              class="h-2 rounded-full transition-all"
                              [ngClass]="
                                i === carouselImageIndex
                                  ? 'w-6 bg-gray-900'
                                  : 'w-2 bg-gray-300 hover:bg-gray-500'
                              "
                              (click)="goToCarouselImage(i)"
                            >
                            </button>
                          </div>

                          <!-- CAPTION -->
                          <div
                            class="mx-auto mt-4 w-full max-w-[260px]"
                            *ngIf="videoStoryTags.includes(postForm.get('tag')?.value)"
                          >
                            <label
                              for="alt-text-carousel"
                              class="mb-1 block text-xs font-medium text-gray-700"
                            >
                              Caption
                            </label>

                            <input
                              id="alt-text-carousel"
                              type="text"
                              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                              [value]="currentImage.alt"
                              (input)="uploadedFiles[carouselImageIndex].alt = $any($event.target).value"
                              placeholder="Enter caption"
                              maxlength="50"
                            />
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- PHOTOLINK FIELDS -->
                    <ng-container *ngIf="postForm.get('tag')?.value === 'photolink'">
                      <div class="mb-6">
                        <div class="mb-2 flex items-center justify-between gap-3">
                          <label class="block text-sm font-semibold text-gray-700">
                            Post Description
                          </label>

                          <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                            Alternative AI Prompt
                          </mat-checkbox>
                        </div>

                        <textarea
                          formControlName="rss_description"
                          rows="3"
                          placeholder="Enter description..."
                          [attr.dir]="textDirection"
                          class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        ></textarea>
                      </div>

                      <div class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          URL
                        </label>

                        <input
                          formControlName="rss_article_url"
                          type="text"
                          placeholder="https://..."
                          [attr.dir]="textDirection"
                          class="h-[44px] w-full rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        />

                        <div
                          *ngIf="postForm.get('rss_article_url')?.invalid && postForm.get('rss_article_url')?.touched"
                          class="mt-1 text-xs text-red-500"
                        >
                          <span *ngIf="postForm.get('rss_article_url')?.errors?.['pattern']">
                            Enter a valid URL (e.g., https://example.com).
                          </span>
                        </div>
                      </div>

                      <div class="mb-6">
                        <label class="mb-2 block text-sm font-semibold text-gray-700">
                          Caption
                        </label>

                        <textarea
                          formControlName="post_title"
                          rows="2"
                          placeholder="Enter title..."
                          [attr.dir]="textDirection"
                          class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                        ></textarea>
                      </div>

                      <div class="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                          <label class="mb-2 block text-sm font-semibold text-gray-700">
                            Post Status
                          </label>

                          <select
                            formControlName="post_status"
                            class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                          >
                            <option value disabled>Select a status</option>
                            <option *ngFor="let s of filteredPostStatuses" [value]="s.value">
                              {{ s.label }}
                            </option>
                          </select>
                        </div>

                        <div>
                          <label class="mb-2 block text-sm font-semibold text-gray-700">
                            Schedule Date & Time
                          </label>

                          <input
                            type="datetime-local"
                            formControlName="scheduled_for"
                            [ngStyle]="{
                              'background-color': postForm.get('scheduled_for')?.disabled ? '#e5e7eb' : '',
                              'color': postForm.get('scheduled_for')?.disabled ? '#9ca3af' : ''
                            }"
                            class="h-[44px] w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400"
                          />
                        </div>
                      </div>
                    </ng-container>

                </div>
                  <!-- END RIGHT COLUMN -->

                </div>
                <!-- END FORM BODY -->

                <!-- SUBMIT -->
                <div *ngIf="postForm.get('tag')?.value" class="mt-8 flex justify-center border-t border-gray-200 pt-6">
                  <button
                    type="submit"
                    [disabled]="isEditBlocked"
                    class="primary-btn h-[50px] cursor-pointer rounded-xl px-10 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Submit
                  </button>
                </div>

              </form>
            </section>
          </div>
        </div>
      </div>
    </div>

    <!-- SIDEBAR -->
    <div class="hidden min-w-0 md:block md:col-span-12 2xl:col-span-3">
      <app-sidebar></app-sidebar>
    </div>

  </div>
</main>